exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3LcvH{display:-webkit-box;display:-ms-flexbox;display:flex}.dELCN{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;list-style:none;margin-left:0;padding-left:0}.dELCN:not(:last-child){margin-right:20px}._3T2K9{font-size:14px;padding:15px;background:#fff;margin-bottom:10px;min-height:60px;border-radius:5px}._3T2K9:last-child{border-bottom:1px solid #c4c4c4}._3xHvy{font-style:normal;font-weight:400;font-size:16px;line-height:120%}._1y0Io{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;font-weight:700;font-size:14px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.mMF89{font-size:14px;font-weight:300;line-height:150%}._1r8NR{font-size:14px;line-height:1.45;list-style:initial;padding-left:25px}.Ycho7{display:none}.NuXul{width:28px;height:28px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f5f5f5;color:gray;border-radius:28px;cursor:pointer}._1SQLg:before{content:\"\\2014\";font-size:15px}.Plj5A:before{content:\"+\";font-size:24px;font-weight:100}", ""]);

// exports
exports.locals = {
	"root": "_3LcvH",
	"group": "dELCN",
	"p": "_3T2K9",
	"title": "_3xHvy",
	"groupTitle": "_1y0Io",
	"item": "mMF89",
	"details": "_1r8NR",
	"detailsHidden": "Ycho7",
	"groupToggleBtn": "NuXul",
	"groupToggleOpened": "_1SQLg",
	"groupToggleClosed": "Plj5A"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/Accordion/Accordion.css
// module id = 3209
// module chunks = 21